"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpoints = void 0;
var tslib_1 = require("tslib");
var lodash_1 = (0, tslib_1.__importDefault)(require("lodash"));
var react_1 = require("react");
var breakpoints_1 = require("../theme/breakpoints");
function useBreakpoints() {
    var _a = (0, react_1.useState)([]), activeBreakpoints = _a[0], setActive = _a[1];
    var matchMedia = window.matchMedia ||
        function matchMediaFallback() {
            return {
                matches: false,
                addListener: function () {
                },
                removeListener: function () {
                },
            };
        };
    (0, react_1.useEffect)(function () {
        var handleWindowResize = lodash_1.default.throttle(function () {
            var active = Object.keys(breakpoints_1.breakpoints).filter(function (name) {
                if (typeof window !== 'undefined') {
                    var mq = matchMedia(breakpoints_1.breakpoints[name]);
                    return mq.matches;
                }
                return null;
            });
            setActive(active);
        }, 500);
        handleWindowResize();
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', handleWindowResize);
        }
        return function () {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', handleWindowResize);
            }
        };
    }, []);
    return activeBreakpoints;
}
exports.useBreakpoints = useBreakpoints;
//# sourceMappingURL=breakpoints.js.map